var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicMobile = function SvgMicMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 18V8.25h.012a5.625 5.625 0 0 1 11.226 0h.012V18a5.625 5.625 0 0 1-11.25 0Z",
    fill: "#fff",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 12.638c.621 0 1.125.503 1.125 1.125V18a7.5 7.5 0 0 0 15 0v-4.237a1.125 1.125 0 0 1 2.25 0V18a9.75 9.75 0 0 1-8.625 9.685v3.065H22.5a1.125 1.125 0 0 1 0 2.25h-9a1.125 1.125 0 0 1 0-2.25h3.375v-3.065A9.749 9.749 0 0 1 8.25 18v-4.237c0-.622.504-1.125 1.125-1.125Z",
    fill: "#fff",
    fillOpacity: 0.85
  })));
};
export default SvgMicMobile;